module.exports = __webpack_public_path__ + "static/media/paraiso-capa.73859174.png";